import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export function useDeletePageCollection() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: (id: number) => api.admin.pages.deleteCollection({ params: { id } }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "page-collections"] });
      toaster.create({
        title: "Collection deleted successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "An error occurred while deleting the collection.";

      toaster.create({
        title: "Failed to delete collection",
        description: errorMessage,
        type: "error",
      });
    },
  });
}
